export const PRESENCE_RESOURCE = 'https://presence.teams.microsoft.com';
export const PRESENCE_RETRY_COUNT = 1;
